<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" ref="dropdown" placement="bottom-end">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_task_list"></i>{{title || '全部项目'}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown filter-file-project">
        <el-cascader-panel :options="options" @change="change" clearable></el-cascader-panel>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: 'update_time_sort'
    }
  },
  data() {
    return {
      select: []
    }
  },
  computed: {
    title() {
      if(this.select && this.select.length > 0) {
        let f = this.options.find(res => res.value === this.select[0])
        let h = f.children.find(res => res.value === this.select[1])
        return `${f.label} / ${h.label}`
      }
    }
  },
  methods: {
    change(val) {
      let value = val[0] ? val : []
      this.$emit('change', value)
      this.select = value
      this.$refs.dropdown.hide()
    }
  }
}
</script>
<style lang="scss">
.filter-file-project {
  width: auto;
  padding: 0;
  border: 0 none;
  .el-cascader-panel.is-bordered {
    border:0 none;
  }
}
</style>
